export function formatWithCommas(value: string): string {
  if (value === '') {
    return '';
  }
  return new Intl.NumberFormat('en-US').format(Number(value));
}
